var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.11612 1.11612C1.60427 0.627961 2.39573 0.627961 2.88388 1.11612L9.5 7.73223L16.1161 1.11612C16.6043 0.627961 17.3957 0.627961 17.8839 1.11612C18.372 1.60427 18.372 2.39573 17.8839 2.88388L11.2678 9.5L17.8839 16.1161C18.372 16.6043 18.372 17.3957 17.8839 17.8839C17.3957 18.372 16.6043 18.372 16.1161 17.8839L9.5 11.2678L2.88388 17.8839C2.39573 18.372 1.60427 18.372 1.11612 17.8839C0.627961 17.3957 0.627961 16.6043 1.11612 16.1161L7.73223 9.5L1.11612 2.88388C0.627961 2.39573 0.627961 1.60427 1.11612 1.11612Z",
    fill: "#19234F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.123d1145e44e5897d49950fdc3fbcfa1.svg";
export { ForwardRef as ReactComponent };